class MenuDrawer extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-menu-toggle]');
    this.panel = this.querySelector('[data-menu-panel]');
    if (!this.button || !this.panel) return;
    this.button.addEventListener('click', () => this.toggle());
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }
  toggle() {
    const isOpen = this.button.getAttribute('aria-expanded') === 'true';
    isOpen ? this.close() : this.open();
  }
  open() {
    this.button.setAttribute('aria-expanded', 'true');
    this.button.textContent = 'Close';
    this.button.setAttribute('aria-label', 'Close menu');
    this.panel.hidden = false;
    document.body.classList.add('menu-open');
    const firstLink = this.panel.querySelector('a');
    if (firstLink) firstLink.focus();
  }
  close() {
    this.button.setAttribute('aria-expanded', 'false');
    this.button.textContent = 'Menu';
    this.button.setAttribute('aria-label', 'Open menu');
    this.panel.hidden = true;
    document.body.classList.remove('menu-open');
    this.button.focus();
  }
}
customElements.define('menu-drawer', MenuDrawer);

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        this.observer.disconnect();
        this.load();
      }, { rootMargin: '300px 0px' });
      this.observer.observe(this);
      return;
    }
    this.load();
  }
  load() {
    const url = this.dataset.url;
    if (!url) return;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim()) this.innerHTML = recommendations.innerHTML;
      })
      .catch(() => {});
  }
}
customElements.define('product-recommendations', ProductRecommendations);

class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const current = Number(this.input.value || 1);
        const next = button.name === 'plus' ? current + 1 : Math.max(1, current - 1);
        this.input.value = next;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
}
customElements.define('quantity-input', QuantityInput);

document.querySelectorAll('[data-variant-select]').forEach((select) => {
  select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const form = select.closest('form');
    const idInput = form && form.querySelector('[name="id"]');
    if (idInput) idInput.value = option.value;
    document.querySelectorAll('[data-product-price]').forEach((price) => {
      if (option.dataset.price) price.textContent = option.dataset.price;
    });
    document.querySelectorAll(`[data-product-submit="${form.id}"]`).forEach((button) => {
      button.disabled = option.dataset.available !== 'true';
      button.textContent = option.dataset.available === 'true' ? `${button.dataset.addLabel} ${option.dataset.price}` : button.dataset.soldLabel;
    });
    document.querySelectorAll('[data-product-availability]').forEach((status) => {
      status.textContent = option.dataset.available === 'true' ? 'Available' : 'Sold out';
      status.dataset.available = option.dataset.available;
    });
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  });
});

document.querySelectorAll('.product-form').forEach((form) => {
  form.addEventListener('submit', (event) => {
    if (form.dataset.submitting === 'true') {
      event.preventDefault();
      return;
    }
    form.dataset.submitting = 'true';
    document.querySelectorAll(`[data-product-submit="${form.id}"]`).forEach((button) => {
      button.setAttribute('aria-disabled', 'true');
      button.textContent = 'Adding…';
    });
  });
});
